// Dati del negozio tenuti in memoria tra una pagina e l'altra (carrello, prodotto, home).
// Durata breve e svuotamento a ogni salvataggio dall'editor: le modifiche si vedono subito.
const TTL_MS = 60 * 1000;
const cache = new Map();

export const getShopCache = (key) => {
  const hit = cache.get(key);
  return hit && Date.now() - hit.at < TTL_MS ? hit.data : null;
};
export const setShopCache = (key, data) => cache.set(key, { at: Date.now(), data });
export const clearShopCache = () => cache.clear();
